import React from "react";
import { IonGrid, IonRow, IonCol, isPlatform } from "@ionic/react";
import "./Rate.scss";
import {ComponentProps} from "./Rate.types";
import { decimal_2_place } from "../../../../web/utils/BasicLogical.Util";

export default ({ length, costBreakdownDescription, costBreakdownRate, costBreakdownRateQlfr, costBreakdownQty, costBreakdownTotalAmount, costCurrency }: ComponentProps) => {
  const isMobile = isPlatform("mobile");
  const paddingClass = isMobile ? "mobile-padding" : "web-padding";
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: costCurrency || "USD",
    minimumFractionDigits: 2
  });
  return (
    <IonGrid className="rate-component">
      <IonRow>
        <IonCol size={isMobile ? "4" : "4.5"} className={paddingClass} data-testid={"charge-description"}>
          {costBreakdownDescription}
        </IonCol>
        <IonCol size={isMobile ? "3.5" : "4"} className={paddingClass} data-testid={"rate-qualifier"}>
          {decimal_2_place(costBreakdownRate)}{"/"}{costBreakdownRateQlfr}
        </IonCol>
        <IonCol size={"1.5"} className={isMobile?paddingClass:"total-qty-label"} data-testid={"qty"}>
          {costBreakdownQty}
        </IonCol>
        <IonCol size={isMobile ? "3" : "2"} className={`${paddingClass} total-cost-label ${(length>3)?"":"total-cost-label-right"}`} data-testid={"total"}>
          {currencyFormatter.format(costBreakdownTotalAmount || 0)}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
